import * as guide from 'app-webtech-core/modules/guide/constants';
import * as linearChannels from 'app-webtech-core/modules/linearChannels/constants';
import * as pairedDevices from 'app-webtech-core/modules/pairedDevices/constants';
import * as player from 'app-webtech-core/modules/player/constants';
import * as podTrackerAds from 'app-webtech-core/modules/podTracker/ads/constants';
import * as userAccount from 'app-webtech-core/modules/userAccount/constants';
import * as vodContent from 'app-webtech-core/modules/vodContent/constants';

export const constants = {
  guide,
  linearChannels,
  pairedDevices,
  player,
  podTrackerAds,
  userAccount,
  vodContent,
};
